import { useState } from 'react';

import { Size, useResizeObserver } from './useResizeObserver';

const defaultRectSize: Size = {
  width: 0,
  height: 0,
};

export const useMeasure = <T extends HTMLElement = HTMLElement>() => {
  const [rect, setRect] = useState<Size>(defaultRectSize);

  const [ref] = useResizeObserver<T>({
    onResize: (next) =>
      setRect((prev) => (prev.width === next.width && prev.height === next.height ? prev : next)),
  });

  return [ref, { width: rect.width, height: rect.height }] as const;
};
